import { useBrand } from "../lib/brand";

/**
 * High-contrast pill that surfaces the currently-active brand everywhere
 * in the app header. Uses the brand's own color as the dominant background
 * so the selection is impossible to miss. Clicking scrolls the sidebar
 * brand switcher into view (kept as the source of truth for switching).
 */
export default function ActiveBrandPill({ size = "md" }) {
    const { currentBrand } = useBrand();

    // Brand badge sticks to the platform's primary accent (configurable
    // from Admin → Configuración general). The per-brand hue is still used
    // for the small contrasting chip on the left and in the sidebar pill.
    const name = currentBrand?.name || "Sin marca";

    const base =
        size === "sm"
            ? "h-8 pl-2 pr-3 text-xs gap-2"
            : "h-10 pl-2.5 pr-4 text-sm gap-2.5";

    return (
        <div
            data-testid="active-brand-pill"
            title={`Marca activa: ${name}`}
            className={`inline-flex items-center rounded-full font-medium select-none transition-all bg-periwinkle-500 text-white ${base}`}
            style={{
                boxShadow:
                    "0 0 0 1px rgba(1,233,189,0.5), 0 0 28px -8px rgba(1,233,189,0.8)",
            }}
        >
            <span
                className="inline-flex items-center justify-center rounded-full bg-white/95 text-[9px] font-mono uppercase tracking-widest px-2 py-0.5 text-periwinkle-600"
                data-testid="active-brand-pill-label"
            >
                Marca
            </span>
            <span
                className="font-display truncate max-w-[160px] text-white"
                data-testid="active-brand-pill-name"
            >
                {name}
            </span>
        </div>
    );
}
